import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import Select from "@/components/Select";

export type AttributeCondition = {
  attribute: string;
  comparator: Comparator;
  value: string;
};

export function AttributeEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const attributeCondtion = JSON.parse(
    condition.data || "{}"
  ) as AttributeCondition;

  function update(data: AttributeCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  return (
    <>
      <input
        type={"text"}
        placeholder="Attribute Name"
        value={attributeCondtion.attribute || ""}
        onChange={(e) => {
          update({ ...attributeCondtion, attribute: e.target.value });
        }}
        className="border rounded-md p-2 w-full"
      />
      <Select
        options={comparatorDefs}
        value={attributeCondtion.comparator}
        onChange={(v) => update({ ...attributeCondtion, comparator: v })}
      />
      {!["exists", "notExists"].includes(attributeCondtion.comparator) && (
        <input
          type={"text"}
          placeholder="Value"
          value={attributeCondtion.value || ""}
          onChange={(e) => {
            update({ ...attributeCondtion, value: e.target.value });
          }}
          className="border rounded-md p-2 w-full"
        />
      )}
    </>
  );
}
